import { demoFile, component, story, CLICK, variant, componentWithVariants } from "system/demo";
import { AdaptiveLayoutArticleQuestionTeaserWithComment, AdaptiveLayoutCMSEmbeddedQuestionTeaser, AdaptiveLayoutQuestionTeaser, ArticleQuestionsAdminScreen, CardStack, CommentPreview, EditorialQuestionFeature, EditorialQuestionTeaser, MiniQuestionPromo, MultiQuestionTeaser, NarrowQuestionTeaserWithComment, QuestionInfo, QuestionVideoOverlayPromo, SingleQuestionTeaser, TeaserButton, teaserPalette, WideQuestionTeaserWithCommnt } from 'feature/teaser/editorial-question';
import { Close, Edit } from "@carbon/icons-react";
import { colorTextOnBlackBackground, colorTextOnLightColorTag } from "component/color";
import { PadBox } from "component/basics";
import { UtilityText } from "component/text";
import { View } from "react-native";

demoFile('feature/teaser/editorial-question', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=6312-22175&t=pgpscnehX1ig2r0m-1'
});

const question = {
    key: 1,
    from: 'a',
    text: 'Is Godzilla good?',
    entryUrl: 'https://example.com/question/1'
};

const questionTwo = {
    key: 2,
    from: 'b',
    text: 'Should we welcome Godzilla to Tokyo?',
};

const commentPreview = {
    key: 1,
    from: 'a',
    text: 'I love Godzilla. He is so cute.',
    time: Date.now(),
    upvoteCount: 5
};

const collections = {
    derived_questionPreview: [
        {key: 1, commentCount: 1234, commentPreview}
    ]
};

// Mini Question Promo
function MiniQuestionPromoDemo() {
    return <View>
        <MiniQuestionPromo question={question} />
        <MiniQuestionPromo question={questionTwo} joinButton />
    </View>;
}
component('MiniQuestionPromo', MiniQuestionPromoDemo, {
    state: { collections }
});

// Single Question Teaser
componentWithVariants('SingleQuestionTeaser', SingleQuestionTeaser, {}, [
    variant(null, {
        args: { question },
        state: { collections }
    }),
    variant('With Editorial Role', {
        args: { question: questionTwo },
        state: { collections, roles: ['Editorial'] }
    })
]);

// Multi Question Teaser
component('MultiQuestionTeaser', MultiQuestionTeaser, {
    args: { questions: [question, questionTwo] },
    state: { collections }
});

// Editorial Question Teaser
componentWithVariants('EditorialQuestionTeaser', EditorialQuestionTeaser, {
    config: EditorialQuestionFeature.defaultConfig
}, [
    variant('With Questions', {
        state: {
            collections: { ...collections, question: [question, questionTwo] }
        }
    }),
    variant('With Questions (Editorial)', {
        state: {
            roles: ['Editorial'],
            collections: { ...collections, question: [question, questionTwo] }
        }
    }),
    variant('No Questions (Editorial)', {
        state: {
            roles: ['Editorial']
        }
    })
]);

// Adaptive Layout Question Teaser
componentWithVariants('AdaptiveLayoutArticleQuestionTeaserWithComment', AdaptiveLayoutArticleQuestionTeaserWithComment, {
    args: { 
        question,
        commentPreview,
        commentCount: 12
    }
}, [
    variant('Green', {
        config: {
            ...EditorialQuestionFeature.defaultConfig,
            teaserColorPalette: teaserPalette.green
        },
        state: { collections }
    }),
    variant('Tan', {
        config: {
            ...EditorialQuestionFeature.defaultConfig,
            teaserColorPalette: teaserPalette.tan
        },
        state: { collections }
    })
]);

// Wide Question Teaser
componentWithVariants('WideQuestionTeaserWithCommnt', WideQuestionTeaserWithCommnt, {}, [
    variant(null, {
        args: {
            questionText: question.text,
            questionKey: question.key,
            entryUrl: question.entryUrl,
            commentPreview,
            commentCount: 12
        },
        config: {
            ...EditorialQuestionFeature.defaultConfig,
            teaserColorPalette: teaserPalette.tan
        }
    }),
    variant('Empty State', {
        args: {
            questionText: question.text,
            questionKey: question.key,
            entryUrl: question.entryUrl,
            commentPreview: null,
            commentCount: 0
        },
        config: {
            ...EditorialQuestionFeature.defaultConfig,
            teaserColorPalette: teaserPalette.green
        }
    })
]);

// Narrow Question Teaser
componentWithVariants('NarrowQuestionTeaserWithComment', NarrowQuestionTeaserWithComment, {
    config: {
        ...EditorialQuestionFeature.defaultConfig,
        teaserColorPalette: teaserPalette.green
    }
}, [
    variant(null, {
        args: {
            questionText: question.text,
            questionKey: question.key,
            entryUrl: question.entryUrl,
            commentPreview: null,
            commentCount: 0
        },
        config: {
            ...EditorialQuestionFeature.defaultConfig,
            teaserColorPalette: teaserPalette.green
        }
    }),
    variant('With Comments', {
        args: {
            questionText: question.text,
            questionKey: question.key,
            entryUrl: question.entryUrl,
            commentPreview,
            commentCount: 12
        }
    }),
    variant('With Beta Tag', {
        args: {
            questionText: question.text,
            questionKey: question.key,
            entryUrl: question.entryUrl,
            commentPreview: null,
            commentCount: 0
        },
        state: {
            modulePublic: {'isBeta': true}
        }
    })
]);

// Question Video Overlay Promo
component('QuestionVideoOverlayPromo', QuestionVideoOverlayPromo, {
    args: { question },
    config: {
        ...EditorialQuestionFeature.defaultConfig,
        teaserColorPalette: teaserPalette.darkTransparent,
        promoTopRightWidgets: [() => <Close size={32} color={colorTextOnBlackBackground} />]
    },
    state: { collections }
});

// Card Stack
function CardStackDemo() {
    return <CardStack>
        <PadBox horiz={20} vert={20}>
            <UtilityText text='Content goes here' />
        </PadBox>
    </CardStack>;
}
component('CardStack', CardStackDemo, {
    config: {
        ...EditorialQuestionFeature.defaultConfig,
        teaserColorPalette: teaserPalette.tan
    }
});

// Teaser Button
component('TeaserButton', TeaserButton, {
    args: {
        text: 'Teaser Button',
        icon: <Edit color={colorTextOnLightColorTag} />
    },
    config: {
        ...EditorialQuestionFeature.defaultConfig,
        teaserColorPalette: teaserPalette.tan
    }
});

// Comment Preview
component('CommentPreview', CommentPreview, {
    args: { commentPreview },
    config: {
        ...EditorialQuestionFeature.defaultConfig,
        teaserColorPalette: teaserPalette.tan
    }
});

// Question Info
component('QuestionInfo', QuestionInfo, {
    args: {
        questionText: question.text,
        questionKey: question.key,
        entryUrl: question.entryUrl,
        commentCount: 42
    },
    config: {
        ...EditorialQuestionFeature.defaultConfig,
        teaserColorPalette: teaserPalette.tan
    }
});

// Article Questions Admin Screen
component('ArticleQuestionsAdminScreen', ArticleQuestionsAdminScreen, {
    state: {
        roles: ['Editorial']
    }
});

// Direct-Linked Question Teaser
component('AdaptiveLayoutCMSEmbeddedQuestionTeaser', AdaptiveLayoutCMSEmbeddedQuestionTeaser, {
    state: {
        globals: {name: 'Is Godzilla good?'},
        collections: {comment: [{key: 1, from: 'a', text: 'I love Godzilla. He is so cute.', time: 1}]}
    },
    config: {
        teaserColorPalette: teaserPalette.green,
        teaserQuestionLabel: "Let's talk about...",
        teaserSingleQuestion: AdaptiveLayoutQuestionTeaser
    }
}); 